<template>
  <div>
    <content-data
    v-if="is_settings"
    :list="list_id"
    editpath="/billing/customers/list/"
    :disable-import="true"
    :search="search"
    ></content-data>

    <action-buttons @add="open_add"></action-buttons>

  </div>
</template>

<script>
import ContentData from '../content/Data'
import SettingsModel from '@/models/settings.js';
import ActionButtons from '@/components/ActionButtons.vue'

export default {
  data () {
    return {
    }
  },

  components: {
    ContentData,
    ActionButtons
  },
  methods:{
    open_add() {
      this.$router.push("/billing/customers/list/" + this.list_id + "/data/new");
    }
  },
  computed: {
    search () {
      return this.$store.state.search_text;
    },
    is_settings() {
      if (this.settings.length > 0) return true;
      return false;
    },
    settings () {
      return SettingsModel.list("billing_config");
    },
    list_id() {
      return this.settings[0].value.customers_list_id;
    }
  }
}
</script>
